<template>
  <div
    :class="[
      'organism single-product-grid',
      'container-' + organism.containerWidth,
      organism.removeMargin,
    ]"
  >
    <div
      v-if="organism.productType === 'quick-move-in'"
      class="pt-12 bg-bc-gray mb-11 container-full-width"
    >
      <h2
        class="text-2xl font-bold leading-none text-center text-gray-800 font-archer sm:text-[32px]"
      >
        {{ organism.title1 }}
      </h2>
      <OrganismsProductGrid
        v-if="homes?.length"
        class="px-8 pb-16 mx-auto pt-11 max-w-7xl"
        :organism="homes"
        type="quick-move-in"
      />
      <MoleculesButtons class="!justify-center pb-24" :buttons="organism" />
    </div>
  </div>
</template>

<style>
.single-product-grid {
}
</style>

<script setup>
import { useAsyncQuery } from "#imports";
import { GET_PRODUCTS_OVERVIEW } from "~/graphql/GetProductsOverview";

const { data, pending, error } = await useAsyncQuery({
  query: GET_PRODUCTS_OVERVIEW,
  key: "products-overview",
});

const homes = computed(() => data?.value?.homes?.nodes ?? []);

const props = defineProps({
  organism: Object,
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
